const getElementsForAnchorHighlighters = (rootState) => rootState.ui.highlighter.anchors;

export default getElementsForAnchorHighlighters;
